var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValidandoArchivo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_268",
    "data-name": "Grupo 268",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_330",
    "data-name": "Rect\\xE1ngulo 330",
    width: 20,
    height: 20,
    fill: "#20164d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_267",
    "data-name": "Grupo 267",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_666",
    "data-name": "Trazado 666",
    d: "M17.909,7.191a.734.734,0,0,0-.734.734v1.7A4.977,4.977,0,0,0,8.4,11a.734.734,0,0,0,1.4.451,3.508,3.508,0,0,1,6.192-.961H14.973a.734.734,0,1,0,0,1.468h2.936a.734.734,0,0,0,.734-.734v-3.3a.734.734,0,0,0-.734-.734",
    transform: "translate(-3.137 -2.697)",
    fill: "#20164d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_667",
    "data-name": "Trazado 667",
    d: "M16.959,17.211a.733.733,0,0,0-.924.472,3.508,3.508,0,0,1-6.192.959h1.018a.734.734,0,1,0,0-1.468H7.924a.734.734,0,0,0-.734.734v3.3a.734.734,0,0,0,1.469,0v-1.7a4.96,4.96,0,0,0,8.752-1.379.7.7,0,0,0-.452-.923",
    transform: "translate(-2.696 -6.44)",
    fill: "#20164d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_668",
    "data-name": "Trazado 668",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0m0,18.125A8.125,8.125,0,1,1,18.125,10,8.134,8.134,0,0,1,10,18.125",
    fill: "#20164d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidandoArchivo);
export default __webpack_public_path__ + "static/media/validandoArchivo.6e552ce47f7337ecc768f6d630c47221.svg";
export { ForwardRef as ReactComponent };